import React, { forwardRef } from 'react';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  hasIcon?: boolean;
}

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ hasError, hasIcon, className = '', ...props }, ref) => {
    const inputClasses = [
      'ui-input__field',
      hasError && 'ui-input__field--error',
      hasIcon && 'ui-input__field--with-icon',
      className
    ].filter(Boolean).join(' ');

    return (
      <input
        ref={ref}
        className={inputClasses}
        {...props}
        autoComplete="on"
      />
    );
  }
);

InputField.displayName = 'InputField';
